<template>
  <span>
    <slot
      :countdown="countdown"
      :days="countdown.days"
      :hours="countdown.hours"
      :minutes="countdown.minutes"
      :seconds="countdown.seconds"
    >
      <div class="flex gap-0.5 items-center">
        <span class="digit">{{ formatDoubleDigit(countdown.days) }}</span>
        <span>:</span>
        <span class="digit">{{ formatDoubleDigit(countdown.hours) }}</span>
        <span>:</span>
        <span class="digit">{{ formatDoubleDigit(countdown.minutes) }}</span>
        <span>:</span>
        <span class="digit">{{ formatDoubleDigit(countdown.seconds) }}</span>
      </div>
    </slot>
  </span>
</template>

<script>
import { formatDoubleDigit } from '@/lib/helpers/transform'

export default {
  name: 'UtilListingCountdown',
  props: {
    // This is a UTC date from the DB
    // However when set in the DB the user's expectation is that
    // it was in BST
    datetime: {
      type: [String, Number, Date],
      required: true
    }
  },
  data() {
    return {
      currentTime: Date.now(),
      intervalId: null,
      formatDoubleDigit
    }
  },
  computed: {
    end() {
      return Date.parse(this.datetime)
    },
    remainingTime() {
      return Math.max(0, this.end - this.currentTime)
    },
    countdown() {
      const seconds = Math.floor(this.remainingTime / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)

      return {
        days: days,
        hours: hours % 24,
        minutes: minutes % 60,
        seconds: seconds % 60
      }
    }
  },
  methods: {
    updateTimer() {
      this.currentTime = Date.now()
    }
  },
  mounted() {
    this.updateTimer()
    this.intervalId = setInterval(this.updateTimer, 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>

<style lang="scss">
.digit {
  @apply bg-black p-1 text-center rounded-md w-10 text-white  font-medium;
}
</style>
